import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'

export function useLoggedIn() {
  return !isEmpty(useSelector((state) => state.app.learner))
}
